module.exports = __webpack_public_path__ + "img/icon_submenu10dark.eb2d1a45.svg";